import molin_26 from '../../assets/images/tra/molin_26.webp';
import molin_27 from '../../assets/images/tra/molin_27.webp';
import molin_28 from '../../assets/images/tra/molin_28.webp';
import molin_29 from '../../assets/images/tra/molin_29.webp';
import MolinHeader from '../../components/MolinHeader';
import '../../styles/common.css'
import { useState } from 'react';
export default function StreetBlock1() {
    const [storyStatus, setStoryStatus] = useState(0);
    return (
        <div className="relative">
            <MolinHeader></MolinHeader>
            {storyStatus === 0 && (
                <div>
                    <img src={molin_26} alt="Hero background" className="w-full h-auto" />
                    <div className="top-[45%] absolute left-[39%] w-[26%] z-[9999] text-left">
                        <div className="flex flex-col">
                            <span className='text-[#000000] text-[2.6vw]' style={{ display: 'block' }}>商</span>
                            <span className="text-[#000000] text-[2.6vw] mt-[-0.8vw]" style={{ display: 'block' }}>业</span>
                            <span className="text-[#000000] text-[2.6vw] mt-[-0.8vw]" style={{ display: 'block' }}>活</span>
                            <span className="text-[#000000] text-[2.6vw] mt-[-0.8vw]" style={{ display: 'block' }}>动</span>
                            <span className="text-[#000000] text-[1.2vw] mt-[-0.4vw] ml-[-0.4vw]" style={{ display: 'block' }}>Markets</span>
                        </div>
                    </div>
                    <div className="top-[40%] absolute left-[45.5%] w-[20%] z-[9999] text-left">
                        <div className="flex flex-col">
                            <span className="text-[#000000] text-[1vw] mt-[5.4vw] leading-[1.3vw] text-justify">明中叶，江浙一带的古玩艺术市场已初具规模，不仅出现了固定的店肆、古董铺，还出现了带有集市性质的设摊交易。                            </span>
                            <span className="text-[#000000] text-[0.6vw] mt-[1.8vw] leading-[1vw] text-justify">By the mid-Ming dynasty, the antique art market in the Jiangnan and Zhejiang regions had already taken shape. Not only did fixed shops and antique stores emerge, but market-style stall transactions also became common, reflecting a thriving and organized commercial network for collecting and trading art.</span>
                        </div>
                    </div>
                    <div className='absolute bottom-[21%] left-[47%] h-auto w-[10vw] transition-transform duration-300 hover:scale-110 cursor-pointer animate-breathe-enter'
                        onClick={() => setStoryStatus(1)}>
                        <div className="flex flex-col text-center">
                            <span className="text-[#000000] text-[1.3vw]">进入</span>
                            <span className="text-[#000000] text-[1vw]">Enter</span>
                        </div>
                    </div>
                </div>
            )}
            {storyStatus === 1 && (
                <div>
                    <img src={molin_27} alt="Hero background" className="w-full h-auto" />
                    <div className="top-[35%] left-[40%] absolute">
                        <button className="rounded-full breathe-l bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
                            onClick={() => setStoryStatus(2)}>
                        </button>
                    </div>
                    <div className="bottom-[25%] left-[78%] absolute">
                        <button className="rounded-full breathe-l bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
                            onClick={() => setStoryStatus(4)}>
                        </button>
                    </div>
                </div>
            )}
            {storyStatus === 2 && (
                <div>
                    <div className="bottom-[30%] left-[83%] absolute">
                        <button className="rounded-full breathe-l bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
                            onClick={() => setStoryStatus(3)}>
                        </button>
                    </div>
                </div>
            )}
            {storyStatus >= 2 && storyStatus < 4 && (
                <div>
                    <img src={molin_28} alt="Hero background" className="w-full h-auto" />
                    <div className="bottom-[45%] left-[30%] absolute">
                        <button className="rounded-full breathe-l bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
                            onClick={() => setStoryStatus(1)}>
                        </button>
                    </div>
                </div>
            )}
            {storyStatus === 3 && (
                <div>
                    <div className={`chat-bubble-base absolute bottom-[45%] left-[85%] transform -translate-x-1/2 chat-bubble-right
                        chat-bubble-fade-in ${storyStatus >= 3 ? 'chat-bubble-fade-in-active' : ''}`}>
                        <span className='mt-[1vw] typing-effect'>“走过的客官们瞧一瞧，小店新上市精品瓷器古玩！”</span>
                        <span className='mb-[1vw] typing-effect'>"Ladies and gentlemen, come and take a look! The finest porcelain antiques are now available at this humble shop!"</span>
                    </div>
                </div>
            )}
            {storyStatus >= 4 && storyStatus < 6 && (
                <div>
                    <img src={molin_29} alt="Hero background" className="w-full h-auto" />
                    <div className="bottom-[40%] left-[78%] absolute">
                        <button className="rounded-full breathe-l bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
                            onClick={() => setStoryStatus(1)}>
                        </button>
                    </div>
                    <div className='absolute bottom-[8%] left-[55%] h-[6vw] w-[10vw] transition-transform duration-300 hover:scale-110'>
                        <div className="flex flex-col text-center font-bold">
                            <span className="text-[#000000] text-[1vw]">项元汴</span>
                            <span className="text-[#000000] text-[0.8vw]">Xiang Yuanbian</span>
                        </div>
                    </div>
                </div>
            )}
            {storyStatus === 4 && (
                <div>
                    <div className="bottom-[40%] left-[30%] absolute">
                        <button className="rounded-full breathe-l bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
                            onClick={() => setStoryStatus(5)}>
                        </button>
                    </div>
                </div>
            )}
            {storyStatus === 5 && (
                <div>
                    <div className={`chat-bubble-base absolute bottom-[58%] left-[50%] transform -translate-x-1/2 chat-bubble-left
                        chat-bubble-fade-in ${storyStatus >= 5 ? 'chat-bubble-fade-in-active' : ''}`}>
                        <span className='mt-[1vw] typing-effect'>客官好眼力！这是我家祖传的宝贝！</span>
                        <span className='mb-[1vw] typing-effect'>You have a good eye, sir! This is my family's ancestral treasure!</span>
                    </div>
                </div>
            )}
        </div>
    )
}